import { render, staticRenderFns } from "./arrive-store-input.vue?vue&type=template&id=53a3f18f&scoped=true&"
import script from "./arrive-store-input.vue?vue&type=script&lang=ts&"
export * from "./arrive-store-input.vue?vue&type=script&lang=ts&"
import style0 from "./arrive-store-input.vue?vue&type=style&index=0&id=53a3f18f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a3f18f",
  null
  
)

export default component.exports